module.exports = __webpack_public_path__ + "img/img21.37234edb.svg";